import styled from '@emotion/styled';

import ReCaptchaContainer from '../../../../../components/ReCaptchaContainer';

export const WelcomeRecaptchaContainer = styled(ReCaptchaContainer)`
  .grecaptcha-badge {
    display: none;
  }
`;
